module.exports = __webpack_public_path__ + "img/18.6710d8e4.png";